import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

export enum ColumnModifier {
  SPAN_1_AND_2 = 'span-1-and-2',
  NO_MARGIN = 'no-margin',
}

type Column = PropsWithChildren<{
  modifier?: Modifier<ColumnModifier>;
}>;

/**
 * Column in a form. Is mainly used within Row.
 * Can contain nodes, elements and Strings as children.
 */
export function Column({ modifier, children }: Column) {
  return <div className={bem('column', modifier)}>{children}</div>;
}
